import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";

import { useDataApi } from "@core/apis";
import type { ValidMeterComponent } from "@core/apis/Platform/types/common";

/**
 * Fetch meter data components for a substation over a date range.
 *
 * Goes through the ISharedDataApi boundary — the PropAI/Platform branching
 * lives in the adapter, not here.
 */
export function useMeterDataQuery(
  substationId: string,
  components: ValidMeterComponent[],
  startDate: DateTime,
  endDate: DateTime,
  options?: { networkUid?: string }
) {
  const dataApi = useDataApi();
  const fromIso = startDate.toISO() ?? "";
  const toIso = endDate.toISO() ?? "";

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["meterData", substationId, components, fromIso, toIso, options?.networkUid],
    queryFn: () =>
      dataApi!.getMeterData(substationId, components, fromIso, toIso, options?.networkUid),
    enabled: !!dataApi && !!substationId && !!fromIso && !!toIso,
  });
}
